var exports = {
  "C": "xaee3c4fa--5ef52c--rubric",
  "i": "xaee3c4fa--5ef52c--wrapper",
};

module.exports = exports;
